<section class="content-layout fullwidth-standard-normal-scroll">
  <header class="header">
    <h1>Notification Settings</h1>
  </header>

  <main class="p-8 w-full">
    <treo-card class="flex flex-col p-8">
      <p class="text-lg font-medium">Notifications</p>

      <mat-divider class="mt-8 mb-8"></mat-divider>

      <form [formGroup]="notificationsForm">
        <p class="font-semibold mb-4">Deal Notifications</p>
        <div class="flex flex-col">
          <div class="mb-2">
            <mat-checkbox
              [color]="'primary'"
              [formControlName]="'new_deal_notifications'"
              (change)="toggleDealNotification()"
            >
              Get notified when a new deal is added.
            </mat-checkbox>
          </div>

          <div class="mb-2">
            <mat-checkbox
              [color]="'primary'"
              [formControlName]="'deal_status_change_notifications'"
              (change)="toggleDealNotification()"
            >
              Get notified when a deal status changes.
            </mat-checkbox>
          </div>

          <div class="mb-2">
            <mat-radio-group
              [color]="'primary'"
              [formControlName]="'deal_notification_preference'"
              class="flex justify-between"
            >
              <mat-radio-button [value]="'all'" class="w-full">
                <p>Notify for all deals</p>
                <p class="text-secondary text-sm">Send a notification for all deals that you have access to.</p>
              </mat-radio-button>
              <mat-radio-button [value]="'following_only'" class="w-full">
                <p>Only notify me on deals that I am involved with</p>
                <p class="text-secondary text-sm">
                  Send a notification for those deals that you are following, tasks that you are following or assigned
                  to or have a role in.
                </p>
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <hr />

          <div class="mb-2">
            <mat-checkbox [color]="'primary'" [formControlName]="'weekly_notifications'">
              Receive a weekly summary email of all deals added and updated during the week.
            </mat-checkbox>
          </div>

          <div class="mb-2">
            <mat-checkbox
              [color]="'primary'"
              [formControlName]="'daily_notifications'"
              (change)="toggleDailyNotifications($event.checked)"
            >
              Receive a daily notification of any tasks, key dates or custom dates associated with a deal that are due.
            </mat-checkbox>
          </div>

          <div class="mb-2">
            <mat-radio-group
              [color]="'primary'"
              [formControlName]="'daily_notifications_preference'"
              class="flex justify-between"
            >
              <mat-radio-button [value]="'all'" class="w-full">
                <p>Send me a daily reminder email for all deals</p>
                <p class="text-secondary text-sm">
                  The email will include dates for all deals that you have access to.
                </p>
              </mat-radio-button>
              <mat-radio-button [value]="'following_only'" class="w-full">
                <p>Send me a daily reminder email for those deals I am involved with</p>
                <p class="text-secondary text-sm">
                  The email will only include those deals that you are following, tasks that you are following or
                  assigned to.
                </p>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <hr />
        <p class="font-semibold mb-4 mt-8">Task Notifications</p>

        <div class="flex flex-col">
          <div class="mb-2">
            <mat-checkbox [color]="'primary'" [formControlName]="'task_notifications_activity_updates'">
              <p>Activity Updates</p>
              <p class="text-secondary">
                Tasks assigned to you, &#64;mentions, completion notifications and date changes notifications that
                you're a follower on
              </p>
            </mat-checkbox>
          </div>

          <div class="mb-2">
            <mat-checkbox [color]="'primary'" [formControlName]="'task_notifications_mentions_only'">
              <p>Mentions Only</p>
              <p class="text-secondary">Tasks assigned to you and &#64;mentions</p>
            </mat-checkbox>
          </div>
        </div>

        <p class="font-semibold mb-4 mt-8">TermSheet Updates</p>

        <div class="flex flex-col">
          <div class="mb-2">
            <mat-checkbox [color]="'primary'" [formControlName]="'ts_new_releases'">
              Get notified when TermSheet releases new features.
            </mat-checkbox>
          </div>
        </div>

        <div class="flex mt-8" [ngClass]="isAdmin() ? 'justify-evenly' : 'justify-start'">
          <ng-container *ngIf="isAdmin()">
            <ts-button type="raised" [disabled]="isFormDisabled()" (click)="saveSettings(true)">
              <span>Apply changes for <strong>everyone</strong></span>
            </ts-button>
          </ng-container>
          <ts-button type="raised" [disabled]="isFormDisabled()" (click)="saveSettings()">
            <span>Apply changes on <strong>my account</strong></span>
          </ts-button>
        </div>
      </form>
    </treo-card>
  </main>
</section>
